"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var LoadingOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M437.08 135.38A384 384 0 01896 512a48 48 0 11-96 0 288 288 0 10-288 288 48 48 0 010 96 384 384 0 01-74.92-760.62z" } }] }, "name": "loading", "theme": "outlined" };
exports.default = LoadingOutlined;
